<div class="container-fluid">
  <div class="row mh-100vh">
    <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
      <div class="m-auto register-login w-lg-75 w-xl-50">
        <div class="text-center mb-5"><img src="assets/v2/img/EPC-logo.svg" style="width: 185px;"></div>
        
        <!-- Checking State -->
        <div *ngIf="isChecking && !isSuccess && !hasError" class="text-center">
          <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">
            Authentification externe<br>
          </h2>
          <div class="alert alert-info" role="alert" style="background-color: #e7f3ff; border-color: #b8daff;">
            <div class="text-center mb-3">
              <i class="pi pi-spin pi-spinner" style="font-size: 2.5rem; color: #0056b3;"></i>
            </div>
            <p class="mb-0 text-center" style="font-size: 16px;">
              Vérification de votre identité en cours...<br>
              <small style="font-size: 14px; color: #666;">Veuillez patienter</small>
            </p>
          </div>
        </div>
        
        <!-- Success State -->
        <div *ngIf="isSuccess" class="text-center">
          <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">
            Authentification réussie !<br>
          </h2>
          <div class="alert alert-success" role="alert">
            <div class="text-center mb-3">
              <i class="pi pi-check-circle" style="font-size: 2.5rem; color: #28a745;"></i>
            </div>
            <p class="mb-0 text-center">{{ successMessage }}</p>
          </div>
        </div>

        <!-- Error State -->
        <div *ngIf="hasError && !isSuccess">
          <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">
            Échec de l'authentification<br>
          </h2>
          
          <div class="alert alert-danger" role="alert">
            <div class="text-center mb-3">
              <i class="pi pi-exclamation-triangle" style="font-size: 2.5rem; color: #dc3545;"></i>
            </div>
            <p class="mb-0 text-center">{{ errorMessage }}</p>
          </div>

          <div class="alert alert-info" role="alert" style="background-color: #f8f9fa; border-color: #dee2e6;">
            <strong>Besoin d'aide ?</strong><br>
            Si vous n'avez pas encore de compte espace pro, vous devez d'abord en créer un 
            avant de pouvoir vous connecter via une application externe.
          </div>

          <div class="form-group mt-4">
            <button class="btn btn-primary btn-block" type="button" (click)="retryLogin()">
              <i class="pi pi-arrow-left"></i>Retour à la connexion
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
      <div></div>
    </div>
  </div>
</div>
